import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Layout } from "pages/TPlusOneProcessing/models";

type InitialState = {
  layout: Layout;
  approver: string;
  transactionStatus: string;
  selectedBatchRows: string[];
  isPushToNIBSSModalOpen: boolean;
  isRefreshStatusModalOpen: boolean;
  isApproveBulkBatchModalOpen: boolean;
  isApproveSingleBatchModalOpen: boolean;
  isRefreshSingleBatchStatusOpen: boolean;
  isPushSingleBatchToNIBSSModalOpen: boolean;
  isChangeBulkBatchApproverModalOpen: boolean;
  isChangeSingleBatchApproverModalOpen: boolean;
};

const initialState: InitialState = {
  approver: "",
  selectedBatchRows: [],
  transactionStatus: "pending",
  isPushToNIBSSModalOpen: false,
  isRefreshStatusModalOpen: false,
  isApproveBulkBatchModalOpen: false,
  isApproveSingleBatchModalOpen: false,
  isRefreshSingleBatchStatusOpen: false,
  isPushSingleBatchToNIBSSModalOpen: false,
  isChangeBulkBatchApproverModalOpen: false,
  isChangeSingleBatchApproverModalOpen: false,
  layout: { title: "", path: "", function: "" },
};

const tPluseOneProcessingSlice = createSlice({
  name: "data-transaction",
  initialState: initialState,

  reducers: {
    setApprover: (state, action: PayloadAction<string>) => {
      state.approver = action.payload;
    },

    updateTransactionStatus: (state, action: PayloadAction<string>) => {
      state.transactionStatus = action.payload;
    },

    setSelectedBatchRows: (state, action: PayloadAction<string[]>) => {
      state.selectedBatchRows = action.payload;
    },

    setIsPushToNIBSSModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isPushToNIBSSModalOpen = action.payload;
    },

    setIsRefreshStatusModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isRefreshStatusModalOpen = action.payload;
    },

    setIsPushSingleBatchToNIBSSModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isPushSingleBatchToNIBSSModalOpen = action.payload;
    },

    setIsApproveBulkBatchModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isApproveBulkBatchModalOpen = action.payload;
    },

    setIsApproveSingleBatchModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isApproveSingleBatchModalOpen = action.payload;
    },

    setIsRefreshSingleBatchStatusOpen: (state, action: PayloadAction<boolean>) => {
      state.isRefreshSingleBatchStatusOpen = action.payload;
    },

    setIsChangeSingleBatchApproverModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isChangeSingleBatchApproverModalOpen = action.payload;
    },

    setIsChangeBulkBatchApproverModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isChangeBulkBatchApproverModalOpen = action.payload;
    },

    updateLayout: (state, action: PayloadAction<Layout>) => {
      state.layout = action.payload;
    },
  },
});

export default tPluseOneProcessingSlice.reducer;
export const {
  setApprover,
  updateLayout,
  setSelectedBatchRows,
  updateTransactionStatus,
  setIsPushToNIBSSModalOpen,
  setIsRefreshStatusModalOpen,
  setIsApproveBulkBatchModalOpen,
  setIsApproveSingleBatchModalOpen,
  setIsRefreshSingleBatchStatusOpen,
  setIsPushSingleBatchToNIBSSModalOpen,
  setIsChangeBulkBatchApproverModalOpen,
  setIsChangeSingleBatchApproverModalOpen,
} = tPluseOneProcessingSlice.actions;
